// extracted by mini-css-extract-plugin
export default {"container":"XtCM3v","content":"qh0aTF","disabled":"W7k4Vk","ltr":"qizurm","rtl":"soKmR7"};